module.exports = __webpack_public_path__ + "img/product2.88797e72.jpg";